var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StatPanel',_vm._b({staticClass:"world-map-stat-panel"},'StatPanel',_vm.$props,false),[_c('div',{staticClass:"canvascontainer"},[_c('canvas',{ref:"canvasElement"})])])}
var staticRenderFns = []

export { render, staticRenderFns }